<template lang="pug">
  .component-selectize-vehicle-slot
    //pre {{items}}
    selectize(v-if="options", :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", @itemRemoved="optionRemoved", placeholder="Vehicle slot")
</template>

<script>
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
  import BaseSelectize from './BaseSelectize'
  import Selectize from "../../../Selectize";

  export default {
    name: "SelectizeVehicleSlot",
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: [
          'id',
          'name'
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.selects.vehicleSlots((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div><small><i class="fa fa-car"></i>VS${item.id}</small></div><div>${item.name}</div></div>`
      },
      renderTemplate(item, escape) {
        return `<div>${item.name}</div>`
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeVehicleSlot.vue?d725937c